import { render, staticRenderFns } from "./MachineList.vue?vue&type=template&id=2972f67a&scoped=true&"
import script from "./MachineList.vue?vue&type=script&lang=js&"
export * from "./MachineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972f67a",
  null
  
)

export default component.exports